import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { apiClient } from '../../../api';
import { CheckTokenExp, formatCurrency, token } from '../../../config';
import { PaymentStatus, TransectionErrorType, TransectionStatus } from '../../../models/transection';
import DataTable from 'react-data-table-component'
import moment from 'moment';
import { Spin, Badge, Button, Input, DatePicker } from 'antd';
import { Search, Calendar } from "lucide-react"
import "./TransactionList.scoped.scss"
import PaginationShowingAndRowPerPage from '../../../components/pagination/PaginationShowingAndRowPerPage/index';
import { useHistory } from "react-router-dom";

const { RangePicker } = DatePicker

const TransactionList = () => {
  const history = useHistory();
  const [transactionDatas, setTransactionDatas] = useState([])
  const [totalItem, setTotalItem] = useState(0)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState({ currentPage: 1, perPage: 10 })
  const [activeTab, setActiveTab] = useState({ value: null, name: "All" })
  const [searchTerm, setSearchTerm] = useState("")
  const [orderDate, setOrderDate] = useState([])

  const tabs = [
    { value: null, name: "All" },
    { value: 2, name: "Pending" },
    { value: 3, name: "Successful" },
    { value: 0, name: "Failed" }
  ]

  const getTransactionData = async () => {
    setLoading(true)

    if (CheckTokenExp()) {
      window.location.href = "#/logout";
    }

    let req = {
      currentpage: pagination?.currentPage,
      itemperpage: pagination?.perPage,
      paymentstatus: activeTab.value,
      searchterm: searchTerm,
      startorderdate: orderDate.length > 0 ? moment(orderDate[0]).format("YYYY-MM-DD") : null,
      endorderdate: orderDate.length > 0 ? moment(orderDate[1]).format("YYYY-MM-DD") : null,
    };

    await apiClient.post('api/ecom/get-transaction-history', JSON.stringify(req)
      , {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-type': 'application/json; charset=UTF-8'
        }
      })
      .then(response => {
        if (response.data.status === 200) {
          setTransactionDatas(response.data.transactions)
          setTotalItem(response.data.count)
        }
      })
      .catch(error => {
        console.table(error);
      })
      .finally(data => {
        setLoading(false)
      });
  }


  const handlePagination = (value) => {
    setPagination({ ...pagination, currentPage: value })
  }

  const handleRowClick = (id) => {
    setLoading(true)
    history.push(`/OrderValidate?oid=${id}`)
  }

  const columns = [
    {
      name: "Account name",
      selector: (row) => row.order.create_by,
      center: "true",
      width: "15%",
    },
    {
      name: "Receipt ref",
      selector: (row) => row.receipt.RE_NO,
      center: "true",
      width: "15%",
      cell: (text, row) => (
        <div>
          {text?.receipt.RE_NO ? text?.receipt.RE_NO : "-"}
        </div>
      ),
    },
    {
      name: "Order Date",
      selector: (row) => row?.order?.create_date,
      center: "true",
      width: "20%",
      cell: (text, row) => {
        return (
          <div>
            {moment(text?.order.create_date).format('DD/MM/YYYY HH:mm')}
          </div>
        );
      }
    },
    {
      name: "Package",
      selector: (row) => row.package_detail_display,
      center: "true",
      width: "20%",
      cell: (text, row) => {
        return (
          <div>
            {text?.receipt.RE_PACKAGE}
          </div>
        );
      }
    },
    {
      name: "Payment Detail",
      center: "true",
      cell: (text, row) => (
        <div
          className={`status-badge`}
          style={{
            color: PaymentStatus[text.order.payment_status]?.color,
            backgroundColor: PaymentStatus[text.order.payment_status]?.background,
          }}
        >
          {PaymentStatus[text.order.payment_status]?.name}
        </div>
      ),
      width: "15%",
      style: { fontSize: "12px" },
    },
    {
      name: "Net amount (฿)",
      selector: (row) => row.netAmount,
      center: "true",
      cell: (row) => <span className="net-amount">{formatCurrency(parseFloat(row.order.net_payment).toFixed(2))}</span>,
      width: "15%",
    },
  ]

  const customStyles = {
    headCells: {
      style: {
        fontSize: "14px",
        color: "#5E5873"
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#5E5873"
      },
    },
    rows: {
      style: {
        fontSize: "14px",
        color: "#5E5873"
      },
    },
  };

  useEffect(() => {
    getTransactionData()
  }, [])

  useEffect(() => {
    getTransactionData()
  }, [orderDate, activeTab, searchTerm, pagination])

  return (
    <Spin spinning={loading}>
      <div className="transaction-list">
        <div className="payment-table">
          {/* Tab Navigation */}
          <div className="tabs">
            <div className="tabs-container">
              {tabs.map((tab) => (
                <button
                  key={tab.value}
                  onClick={() => { setActiveTab(tab); setPagination({ ...pagination, currentPage: 1 }) }}
                  className={`tab-button ${activeTab?.value === tab?.value ? "tab-button-active" : ""}`}
                >
                  {tab.name}
                </button>
              ))}
            </div>
          </div>

          <div className='transaction-table-container'>
            {/* Search and Filter Bar */}
            <div className="controls">
              <div className="search-container">
                <Search className="search-icon" />
                <Input
                  type="text"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  // onChange={(value) => getTransactionData("text", value)}
                  className="search-input"
                />
              </div>

              <div className="relative">
                <RangePicker
                  className='order-date-picker'
                  placeholder='Order Date'
                  // onChange={(value) => getTransactionData("date", value)}
                  onChange={(value) => setOrderDate(value)}
                  value={orderDate}
                  format={"YYYY-MM-DD"}
                />
              </div>
            </div>

            {/* Data Table */}
            <div>
              <DataTable
                className='payment-table-list'
                columns={columns}
                data={transactionDatas}
                paginationRowsPerPageOptions={[10, 20, 50, 100]}
                noDataComponent={<div className="no-data">No records found</div>}
                customStyles={customStyles}
                onRowClicked={(row) => handleRowClick(row.order.id)}
              />
              <PaginationShowingAndRowPerPage
                currentPage={pagination?.currentPage}
                perPage={pagination?.perPage}
                totalItems={totalItem}
                onPageChange={(val) => handlePagination(val)}
                className={""}
              />
            </div>
          </div>

        </div>
      </div>
    </Spin>
  )
}

export default TransactionList